export const setAuthTokenCookie = (token: string) => {
    document.cookie = `authToken=${token}; path=/; secure; domain=.coxautoinc.com; SameSite=None`;
};
